// extracted by mini-css-extract-plugin
export default {"comments":"commentList_comments__NaVDg","details":"commentList_details__Ce3kG"};